import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-556b90cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings" }
const _hoisted_2 = { class: "settings__list" }
const _hoisted_3 = {
  key: 0,
  class: "settings__item"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("resume")
const _hoisted_5 = { class: "settings__item" }
const _hoisted_6 = { class: "settings__item" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("editor")
const _hoisted_8 = { class: "settings__item" }
const _hoisted_9 = { class: "settings__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_select = _resolveComponent("base-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_ctx.isPaused)
        ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
            _createVNode(_component_base_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('resumed'))),
              class: "resume"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", _hoisted_5, [
        _createVNode(_component_base_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('started', _ctx.speed, _ctx.level))),
          class: "start"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.startButtonTitle), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/editor",
          custom: ""
        }, {
          default: _withCtx(({ navigate, href }) => [
            _createVNode(_component_base_button, {
              onClick: navigate,
              onKeypress: _withKeys(navigate, ["enter"]),
              tag: "a",
              href: href
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 2
            }, 1032, ["onClick", "onKeypress", "href"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_8, [
        _createVNode(_component_base_input, {
          modelValue: _ctx.speed,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.speed) = $event)),
          label: "game speed",
          type: "range",
          min: "8",
          max: "28",
          step: "2"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("li", _hoisted_9, [
        _createVNode(_component_base_select, {
          modelValue: _ctx.level,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.level) = $event)),
          label: "select level",
          options: _ctx.levels
        }, null, 8, ["modelValue", "options"])
      ])
    ])
  ]))
}